var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"mb-7",class:_vm.propClass},[_c('v-toolbar',{attrs:{"flat":""}},[_vm._t("left-toolbar"),_c('v-spacer'),_vm._t("right-toolbar")],2),_c('v-divider'),_c('div',{staticClass:"pa-md-2 pa-xs-0"},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }